// Scroll-fade for c_article_banner's lower-left meta strip (.c_article_b_l:
// photography / author). Mirrors the c_landing_banner pinned-meta fade
// (assets/c-landing-banner.js): opacity is recomputed every scroll frame as a
// continuous function of position, so the group eases OUT as it scrolls up and
// eases BACK IN when you scroll back to the banner — a soft, reversible fade.
//
// It must be fully gone BEFORE it reaches the pinned upper-left copy
// (.c_article_headings, position:fixed at top:80px). So the fade "end" line is
// the live bottom edge of that pinned block (+ a small gap), not a fixed value.
// On mobile / when the copy isn't pinned, fall back to fading near the top.
(function () {
  var FADE = 100;   // px band over which the group eases in/out
  var GAP = 32;     // clear this many px below the pinned copy before it overlaps
  var FALLBACK = 80; // fade line when the copy isn't pinned (mobile) or is empty

  function init() {
    var groups = document.querySelectorAll(".c_article_b_l");
    if (!groups.length) return;

    function fadeLine() {
      var head = document.querySelector(".c_article_headings");
      if (head) {
        var hr = head.getBoundingClientRect();
        if (getComputedStyle(head).position === "fixed" && hr.height) {
          return hr.bottom + GAP; // fully faded before its top meets the copy
        }
      }
      return FALLBACK;
    }

    function update() {
      var end = fadeLine();
      groups.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (!r.height) { el.style.opacity = ""; return; }
        var top = r.top;
        var o = top >= end + FADE ? 1 : (top <= end ? 0 : (top - end) / FADE);
        el.style.opacity = o;
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    window.addEventListener("load", update);
    update();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
